'use strict';

var Sugar = require('sugar-core'),
    _numberOptions = require('./var/_numberOptions');

module.exports = Sugar.Number.setOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/setOption.js
// module id = 739
// module chunks = 0